<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>视光配镜</el-breadcrumb-item>
      <el-breadcrumb-item>进货</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.purchasetime" @keyup.enter.native="clicksearch" placeholder="请输入采购时间" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.producttype" @keyup.enter.native="clicksearch" placeholder="请输入产品类型" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.brand" @keyup.enter.native="clicksearch" placeholder="请输入品牌" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.suppliers" @keyup.enter.native="clicksearch" placeholder="请输入供应商" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.productname" @keyup.enter.native="clicksearch" placeholder="请输入商品名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.specifications" @keyup.enter.native="clicksearch" placeholder="请输入规格型号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="primary" @click="clickexcel" plain v-if="SubRule_Optometrist_ExportImportJinHuoXinXi">导出</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item>
            <el-button type="danger" plain @click="clickmuban">下载新增导入模板</el-button>
            <TencentyunCosUploadExcel @change="changeTencentyunCosUploadExcelAdd" title="新增导入"></TencentyunCosUploadExcel>
            <TencentyunCosUploadExcel @change="changeTencentyunCosUploadExcelUpdate" title="覆盖导入(先导出,且不能修改编号)" v-if="SubRule_Optometrist_ExportImportJinHuoXinXi"></TencentyunCosUploadExcel>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Purchasetime" label="采购时间" min-width="6%"></el-table-column>
          <el-table-column prop="Producttype" label="产品类型" min-width="6%"></el-table-column>
          <el-table-column prop="Brand" label="品牌" min-width="6%"></el-table-column>
          <el-table-column prop="Suppliers" label="供应商" min-width="8%"></el-table-column>
          <el-table-column prop="Productname" label="商品名称" min-width="6%"></el-table-column>
          <el-table-column prop="Specifications" label="规格型号" min-width="6%"></el-table-column>
          <el-table-column prop="Units" label="计量单位" min-width="6%"></el-table-column>
          <el-table-column prop="Phone" label="联系方式" min-width="6%"></el-table-column>
          <el-table-column prop="Shipaddress" label="发货地址" min-width="9%"></el-table-column>
          <el-table-column prop="Payinfo" label="支付信息" min-width="18%"></el-table-column>
          <el-table-column prop="Purchasenum" label="采购数量" min-width="6%"></el-table-column>
          <el-table-column prop="Purchaseprice" label="采购价" min-width="6%"></el-table-column>
          <el-table-column prop="Shopprice" label="代理商价" min-width="6%"></el-table-column>
          <el-table-column prop="Retailprice" label="零售价" min-width="6%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="8%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickmodify(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加进货" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="170px">
        <el-form-item label="采购时间" class="addAdminForm">
          <el-date-picker v-model="addForm.purchasetime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="产品类型" class="addAdminForm">
          <el-input v-model="addForm.producttype"></el-input>
        </el-form-item>
        <el-form-item label="品牌" class="addAdminForm">
          <el-input v-model="addForm.brand"></el-input>
        </el-form-item>
        <el-form-item label="供应商" class="addAdminForm">
          <el-input v-model="addForm.suppliers"></el-input>
        </el-form-item>
        <el-form-item label="商品名称" class="addAdminForm">
          <el-input v-model="addForm.productname"></el-input>
        </el-form-item>
        <el-form-item label="规格型号" class="addAdminForm">
          <el-input v-model="addForm.specifications"></el-input>
        </el-form-item>
        <el-form-item label="计量单位" class="addAdminForm">
          <el-input v-model="addForm.units"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" class="addAdminForm">
          <el-input v-model="addForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="发货地址" class="addAdminForm">
          <el-input v-model="addForm.shipaddress"></el-input>
        </el-form-item>
        <el-form-item label="支付信息" class="addAdminForm">
          <el-input v-model="addForm.payinfo"></el-input>
        </el-form-item>
        <el-form-item label="采购数量" class="addAdminForm">
          <el-input v-model="addForm.purchasenum"></el-input>
        </el-form-item>
        <el-form-item label="采购价" class="addAdminForm">
          <el-input v-model="addForm.purchaseprice"></el-input>
        </el-form-item>
        <el-form-item label="代理商价" class="addAdminForm">
          <el-input v-model="addForm.shopprice"></el-input>
        </el-form-item>
        <el-form-item label="零售价" class="addAdminForm">
          <el-input v-model="addForm.retailprice"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <!-- 修改 start -->
    <el-tab-pane label="修改进货" name="three" disabled="disabled">
      <el-form :model="editForm" ref="editFormRef" label-width="170px">
        <el-form-item label="采购时间" class="addAdminForm">
          <el-date-picker v-model="editForm.purchasetime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="产品类型" class="addAdminForm">
          <el-input v-model="editForm.producttype"></el-input>
        </el-form-item>
        <el-form-item label="品牌" class="addAdminForm">
          <el-input v-model="editForm.brand"></el-input>
        </el-form-item>
        <el-form-item label="供应商" class="addAdminForm">
          <el-input v-model="editForm.suppliers"></el-input>
        </el-form-item>
        <el-form-item label="商品名称" class="addAdminForm">
          <el-input v-model="editForm.productname"></el-input>
        </el-form-item>
        <el-form-item label="规格型号" class="addAdminForm">
          <el-input v-model="editForm.specifications"></el-input>
        </el-form-item>
        <el-form-item label="计量单位" class="addAdminForm">
          <el-input v-model="editForm.units"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" class="addAdminForm">
          <el-input v-model="editForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="发货地址" class="addAdminForm">
          <el-input v-model="editForm.shipaddress"></el-input>
        </el-form-item>
        <el-form-item label="支付信息" class="addAdminForm">
          <el-input v-model="editForm.payinfo"></el-input>
        </el-form-item>
        <el-form-item label="采购数量" class="addAdminForm">
          <el-input v-model="editForm.purchasenum"></el-input>
        </el-form-item>
        <el-form-item label="采购价" class="addAdminForm">
          <el-input v-model="editForm.purchaseprice"></el-input>
        </el-form-item>
        <el-form-item label="代理商价" class="addAdminForm">
          <el-input v-model="editForm.shopprice"></el-input>
        </el-form-item>
        <el-form-item label="零售价" class="addAdminForm">
          <el-input v-model="editForm.retailprice"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 修改 end -->

  </el-tabs>
  </div>
</template>

<script>
import TencentyunCosUploadExcel from '@/components/TencentyunCosUploadExcel.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadExcel
  },
  name: 'MyOptometristProductin',
  data () {
    return {
      activeName: 'first',
      addForm: {
        purchasetime: '',
        producttype: '',
        brand: '',
        suppliers: '',
        productname: '',
        specifications: '',
        units: '',
        phone: '',
        shipaddress: '',
        payinfo: '',
        purchasenum: '0',
        purchaseprice: '0',
        operationprice: '0',
        shopprice: '0',
        retailprice: '0'
      },
      addFormBack:[],
      editForm: {
        id: '0',
        purchasetime: '',
        producttype: '',
        brand: '',
        suppliers: '',
        productname: '',
        specifications: '',
        units: '',
        phone: '',
        shipaddress: '',
        payinfo: '',
        purchasenum: '',
        purchaseprice: '',
        operationprice: '',
        shopprice: '',
        retailprice: ''
      },
      // 查询
      keywords: {
        purchasetime: '',
        producttype: '',
        brand: '',
        suppliers: '',
        productname: '',
        specifications: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      SubRule_Optometrist_ExportImportJinHuoXinXi: false,
    }
  },
  mounted () {
    this.addFormBack = Vue.prototype.CloneObj(this.addForm)

    this.apiGetOptometristProductinNum()
    this.apiGetOptometristProductinList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_Optometrist_ExportImportJinHuoXinXi', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Optometrist_ExportImportJinHuoXinXi = true
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    clickexcel () {
      this.apiExcelOptometristJinHuoXinXi()
    },
    clickadd () {
      this.apiAddOptometristProductin()
    },
    clickmuban () {
      window.open('https://erp-1256233047.cos.ap-shanghai.myqcloud.com/muban/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF%E9%85%8D%E9%95%9C%E8%BF%9B%E8%B4%A7.xlsx')
    },
    changeTencentyunCosUploadExcelAdd (url) {
      this.apiExcelImport('22102501',url)
    },
    changeTencentyunCosUploadExcelUpdate (url) {
      this.apiExcelImport('24042802',url)
    },
    clickmodify (row) {
      this.activeName = 'three'

      this.editForm.id = row.Id
      this.editForm.purchasetime = row.Purchasetime
      this.editForm.producttype = row.Producttype
      this.editForm.brand = row.Brand
      this.editForm.suppliers = row.Suppliers
      this.editForm.productname = row.Productname
      this.editForm.specifications = row.Specifications
      this.editForm.units = row.Units
      this.editForm.phone = row.Phone
      this.editForm.shipaddress = row.Shipaddress
      this.editForm.payinfo = row.Payinfo
      this.editForm.purchasenum = row.Purchasenum
      this.editForm.purchaseprice = row.Purchaseprice
      this.editForm.operationprice = row.Operationprice
      this.editForm.shopprice = row.Shopprice
      this.editForm.retailprice = row.Retailprice
    },
    clicksave () {
      this.apiEditOptometristProductin()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelOptometristProductin(row.Id)
      })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetOptometristProductinNum()
      this.apiGetOptometristProductinList()
    },
    delaysearch () {
      var that = this
      setTimeout(function () {
        that.clicksearch()
      }, 2000)
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetOptometristProductinList()
    },
    apiGetOptometristProductinNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        purchasetime: that.keywords.purchasetime,
        producttype: that.keywords.producttype,
        brand: that.keywords.brand,
        suppliers: that.keywords.suppliers,
        productname: that.keywords.productname,
        specifications: that.keywords.specifications
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristProductinNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetOptometristProductinList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        purchasetime: that.keywords.purchasetime,
        producttype: that.keywords.producttype,
        brand: that.keywords.brand,
        suppliers: that.keywords.suppliers,
        productname: that.keywords.productname,
        specifications: that.keywords.specifications
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristProductinList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddOptometristProductin: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.addForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddOptometristProductin, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetOptometristProductinNum()
            that.apiGetOptometristProductinList()

            // 清空
            that.addForm = Vue.prototype.CloneObj(that.addFormBack)
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelOptometristProductin: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelOptometristProductin, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetOptometristProductinNum()
            that.apiGetOptometristProductinList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditOptometristProductin: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.editForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditOptometristProductin, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetOptometristProductinNum()
            that.apiGetOptometristProductinList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelImport: function (exceltype,url) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        exceltype: exceltype,
        fileurl: url
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelImport, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
          that.delaysearch()
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelOptometristJinHuoXinXi: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        purchasetime: that.keywords.purchasetime,
        producttype: that.keywords.producttype,
        brand: that.keywords.brand,
        suppliers: that.keywords.suppliers,
        productname: that.keywords.productname,
        specifications: that.keywords.specifications
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelOptometristJinHuoXinXi, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
